import React, { useEffect, useContext, useReducer } from 'react'
import reducer from '../reducers/filter_reducer'
import {
  LOAD_PRODUCTS,
  SET_GRIDVIEW,
  SET_LISTVIEW,
  UPDATE_SORT,
  SORT_PRODUCTS,
  UPDATE_FILTERS,
  FILTER_PRODUCTS,
  CLEAR_FILTERS,
} from '../actions'
import { useProductsContext } from './products_context'

const initialState = {
  filtered_products:[],
  all_products:[],
  grid_view: true,
  sort:'price-lowest',
  filters:{
    text:'',
    company:'all',
    category:'all',
    colors:'all',
    min_price:0,
    max_price:0,
    price:0,
    shipping: false
  }
}



const FilterContext = React.createContext()

export const FilterProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState)
const {products} = useProductsContext()
const {text, company, category, colors, min_price, max_price, price, shipping} = state.filters


// useEffect(()=>{

//   dispatch({type: LOAD_PRODUCTS, payload: products})
// dispatch({type: SORT_PRODUCTS})

// },[products, state.sort])


// useEffect(()=>{
  
//   dispatch({type: FILTER_PRODUCTS, payload: {text, company, category, colors, min_price, max_price, price, shipping}, payload2: products})
// },[state.filters])

useEffect(()=>{

  dispatch({type: LOAD_PRODUCTS, payload: products})
// dispatch({type: SORT_PRODUCTS})

},[products])

useEffect(()=>{

dispatch({type: SORT_PRODUCTS})

},[products, state.sort, state.filters])


useEffect(()=>{
  
  dispatch({type: FILTER_PRODUCTS, payload: {text, company, category, colors, min_price, max_price, price, shipping}, payload2: products})
},[state.filters])


const setGridView = ()=>{
  dispatch({type: SET_GRIDVIEW})
}
const setListView = ()=>{
  dispatch({type: SET_LISTVIEW})
}

const updateSort =(e)=>{
  
  const value = e.target.value

  dispatch({type: UPDATE_SORT, payload: value})
}

const updateFilters=(e)=>{
  let value = e.target.value
    const name = e.target.name

  if(name === 'category'){
      value = e.target.textContent
     
    }
  
  if(name === 'colors'){
  
    value = e.target.dataset.id
 
    }
  if(name === 'shipping'){
  
    value = e.target.checked
 
    }
  if(name === 'price'){
  
    value = Number(value)
 
    }
  dispatch({type: UPDATE_FILTERS, payload: {value, name}})
}










const clearFilters = ()=>{
console.log();
  dispatch({type: CLEAR_FILTERS})
}


  return (
    <FilterContext.Provider value={{...state, setGridView, setListView, updateSort, updateFilters, clearFilters }}>
      {children}
    </FilterContext.Provider>
  )
}
// make sure use
export const useFilterContext = () => {
  return useContext(FilterContext)
}
